module.exports = __webpack_public_path__ + "static/media/pontilhado.82bfca46.svg";